module.exports = __webpack_public_path__ + "img/bg4.e0708825.png";